/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStepOut = createReactComponent("step-out", "IconStepOut", [
  ["path", { d: "M12 3l0 12", key: "svg-0" }],
  ["path", { d: "M16 7l-4 -4", key: "svg-1" }],
  ["path", { d: "M8 7l4 -4", key: "svg-2" }],
  ["path", { d: "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-3" }]
]);

export { IconStepOut as default };
//# sourceMappingURL=IconStepOut.js.map
